/**
 * 시험안내 리스트 뷰 카운팅용 경로 판별 유틸.
 * pathname 기준으로 "/exam 진입" 여부를 판단할 때 사용.
 */

const EXAM_LIST_PATH = '/exam';

function normalizePath(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

/**
 * 시험안내 메인 리스트 pathname 여부
 * - /exam 또는 /exam/
 */
export function isExamList(pathname: string): boolean {
  return normalizePath(pathname) === EXAM_LIST_PATH;
}

/**
 * 시험안내 리스트 "진입" 카운트 여부
 * - 현재가 /exam 이고, 이전 경로가 /exam 하위가 아닐 때 true
 */
export function shouldCountExamListEntry(
  prevPath: string,
  currentPath: string,
): boolean {
  if (!isExamList(currentPath)) return false;
  if (!prevPath) return true;

  const normalizedPrevPath = normalizePath(prevPath);
  return (
    normalizedPrevPath !== EXAM_LIST_PATH &&
    !normalizedPrevPath.startsWith('/exam/')
  );
}
